module.exports = __webpack_public_path__ + "img/logo_updated.f5a17049.jpeg";